import React, { useState, useEffect } from 'react';
import { Form, Input, Select, DatePicker, Row, Col, message, Modal, Spin } from 'antd';
import { UploadOutlined, LoadingOutlined } from '@ant-design/icons';
import { env } from '../../configs/EnvironmentConfig';
import { formatterNumber } from '../../helpers/input_format';

const { Option } = Select;

const OutstandingPaymentReq = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [fileListUpload, setFileListUpload] = useState([]);
  
  const [kategoriList, setKategoriList] = useState([]);
  const [subKategoriList, setSubKategoriList] = useState([]);
  const [bankList, setBankList] = useState([]);

  useEffect(() => {
    fetchKategori();
    fetchBank();
  }, []);

  const fetchKategori = async () => {
    try {
      const response = await fetch(`${env.API}/core/kategori/list`);
      if (response.ok) {
        const result = await response.json();
        if (result && result.data) {
          setKategoriList(result.data);
        }
      }
    } catch (error) {
      console.error('Error fetching kategori:', error);
      message.error('Gagal mengambil data Kategori');
    }
  };

  const fetchBank = async () => {
    try {
      const response = await fetch(`${env.API}/core/bank`);
      if (response.ok) {
        const result = await response.json();
        if (result && result.data) {
          const sortedData = result.data.sort((a, b) => 
            a.bank_name.localeCompare(b.bank_name)
          );
          setBankList(sortedData);
        }
      }
    } catch (error) {
      console.error('Error fetching bank:', error);
      message.error('Gagal mengambil data Bank');
    }
  };

  const fetchSubKategori = async (kategoriId) => {
    try {
      const response = await fetch(`${env.API}/core/kategori/subkategori/${kategoriId}`);
      if (response.ok) {
        const result = await response.json();
        if (result && result.data) {
          setSubKategoriList(result.data);
        }
      }
    } catch (error) {
      console.error('Error fetching sub kategori:', error);
      message.error('Gagal mengambil data Sub Kategori');
    }
  };

  const handleKategoriChange = (value) => {
    form.setFieldsValue({ sub_kategori_id: undefined });
    fetchSubKategori(value);
  };

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const formData = new FormData();
      
      Object.keys(values).forEach((key) => {
        if (key === 'invoice_file') {
          if (fileListUpload.length > 0) {
            formData.append(key, fileListUpload[0].originFileObj);
          }
        } else if (key === 'due_date_transfer' && values[key]) {
             formData.append(key, values[key].format('YYYY-MM-DD'));
        } else if (key === 'nominal' && values[key] !== undefined && values[key] !== null) {
             formData.append(key, String(values[key]).replace(/\D/g, ''));
        } else if (values[key] !== undefined && values[key] !== null) {
          formData.append(key, values[key]);
        }
      });

      formData.append('status_outstanding', 'Diajukan');

      const response = await fetch(`${env.API}/core/outstanding-payment-req`, {
        method: 'POST',
        body: formData,
      });
      
      const responseData = await response.json();
      setLoading(false);

      if (response.ok) {
        message.success('Pengajuan Outstanding Payment Berhasil Terkirim');
        form.resetFields();
        setFileListUpload([]);
      } else {
        Modal.error({
          title: 'Gagal Dikirim',
          content: responseData.data?.message || responseData.message || 'Terjadi kesalahan saat mengirim data',
        });
      }
    } catch (error) {
      setLoading(false);
      Modal.error({
        title: 'Kesalahan',
        content: 'Terjadi kesalahan sistem: ' + error.message,
      });
    }
  };

  const rulesRequired = () => [{ required: true, message: 'Tidak boleh kosong' }];
  const rulesSelect = () => [{ required: true, message: 'Pilih salah satu' }];

  return (
    <>
      <Form
        layout="vertical"
        name="outstanding_payment_req"
        form={form}
        onFinish={onFinish}
      >
        <div>
          <div className="tambah-pr-from-input-wraper-content">
            <div className="header-from-input-wraper-inline">
              <div className="header-from-input-wraper-title">
                <div>
                  <h1 style={{ fontSize: '18px', fontWeight: '600', color: 'black' }}>
                    Outstanding Payment Req
                  </h1>
                  <p style={{ color: '#6F6C6C', fontSize: '13px' }}>
                    Masukkan data outstanding payment untuk menyimpan dan memantau payment.
                  </p>
                </div>
                
                <div className="tambah-pr-wraper-border">
                  <div className="tambah-pr-wraper-border-inline">
                    <Row gutter={[16, 16]}>
                      
                      <Col xs={24} sm={24}>
                        <Form.Item
                          hasFeedback
                          name="nama_pic"
                          label="Nama PIC"
                          rules={rulesRequired()}
                        >
                          <Input placeholder="Masukkan nama pic" />
                        </Form.Item>
                      </Col>


                      <Col xs={24} sm={12}>
                        <Form.Item
                          hasFeedback
                          name="no_po"
                          label="No. PO"
                          rules={rulesRequired()}
                        >
                          <Input placeholder="Masukkan no. po" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12}>
                        <Form.Item
                          hasFeedback
                          name="jenis_transaksi"
                          label="Jenis Transaksi"
                          rules={rulesSelect()}
                        >
                          <Select placeholder="Pilih salah satu">
                            <Option value="Payment">Payment</Option>
                            <Option value="Reimburse">Reimburse</Option>
                            <Option value="Cash Advance">Cash Advance</Option>
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12}>
                        <Form.Item
                          hasFeedback
                          name="kategori_id"
                          label="Kategori"
                          rules={rulesSelect()}
                        >
                          <Select 
                            placeholder="Pilih salah satu"
                            onChange={handleKategoriChange}
                            showSearch
                            optionFilterProp="children"
                          >
                            {kategoriList.map((item) => (
                              <Option key={item.id} value={item.id}>{item.name}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12}>
                        <Form.Item
                          hasFeedback
                          name="sub_kategori_id"
                          label="Sub Kategori"
                          rules={rulesSelect()}
                        >
                          <Select 
                            placeholder="Pilih salah satu"
                            showSearch
                            optionFilterProp="children"
                            disabled={!form.getFieldValue('kategori_id')}
                          >
                            {subKategoriList.map((item) => (
                              <Option key={item.id} value={item.id}>{item.name}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12}>
                        <Form.Item
                          hasFeedback
                          name="status_pajak"
                          label="Status Pajak"
                          rules={rulesSelect()}
                        >
                          <Select placeholder="Pilih salah satu">
                            <Option value="Gross up">Gross up</Option>
                            <Option value="Dipotong">Dipotong</Option>
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12}>
                        <Form.Item
                          hasFeedback
                          name="ppn"
                          label="PPN"
                          rules={rulesSelect()}
                        >
                          <Select placeholder="Pilih salah satu">
                            <Option value="Ya">Ya</Option>
                            <Option value="Tidak">Tidak</Option>
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12}>
                        <Form.Item
                          hasFeedback
                          name="nominal"
                          label="Nominal"
                          rules={rulesRequired()}
                        >
                          <Input
                            placeholder="Masukkan nominal"
                            onChange={(e) => {
                              let value = e.target.value.replace(/\D/g, "").replace(/^0+/, '');
                              form.setFieldsValue({ nominal: value ? formatterNumber(value) : null });
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12}>
                        <Form.Item
                          hasFeedback
                          name="due_date_transfer"
                          label="Due Date Transfer"
                          rules={rulesRequired()}
                        >
                          <DatePicker 
                            placeholder="Pilih tanggal"
                            style={{ width: '100%' }}
                            format="YYYY-MM-DD"
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={8}>
                        <Form.Item
                          hasFeedback
                          name="bank_id"
                          label="Nama Bank"
                          rules={rulesSelect()}
                        >
                          <Select 
                            placeholder="Pilih salah satu"
                            showSearch
                            optionFilterProp="children"
                          >
                            {bankList.map((bank) => (
                              <Option key={bank.id} value={bank.id}>{bank.bank_name}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={8}>
                        <Form.Item
                          hasFeedback
                          name="nama_pemilik_rekening"
                          label="Nama Pemilik Rekening"
                          rules={[
                            ...rulesRequired(),
                            { pattern: /^[A-Za-z\s]+$/, message: 'Hanya boleh berisi huruf' }
                          ]}
                        >
                          <Input 
                            placeholder="Masukkan nama pemilik rekening" 
                            onChange={(e) => {
                              const value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                              form.setFieldsValue({ nama_pemilik_rekening: value });
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={8}>
                        <Form.Item
                          hasFeedback
                          name="no_rekening"
                          label="No Rekening"
                          rules={[
                            ...rulesRequired(),
                            { pattern: /^[0-9]+$/, message: 'Hanya boleh berisi angka' }
                          ]}
                        >
                          <Input 
                            placeholder="Masukkan no. rekening" 
                            onChange={(e) => {
                              let value = e.target.value.replace(/\D/g, "").replace(/^0+/, '');
                              form.setFieldsValue({ no_rekening: value });
                            }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    
                    <Form.Item
                      label="Upload Invoice"
                      name="invoice_file"
                      rules={rulesRequired()}
                    >
                      <Input
                        placeholder="Pilih berkas"
                        readOnly
                        suffix={<UploadOutlined style={{ fontSize: '18px', color: '#8c8c8c' }} />}
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          const input = document.createElement('input');
                          input.type = 'file';
                          input.accept = '.pdf';
                          input.onchange = (e) => {
                            const file = e.target.files[0];
                            if (file) {
                              const isPDF = file.type === 'application/pdf';
                              const isLt2M = file.size / 1024 / 1024 < 2.5;

                              if (!isPDF) {
                                message.error('File harus berformat PDF!');
                                return;
                              }
                              if (!isLt2M) {
                                message.error('File tidak boleh lebih dari 2.5MB!');
                                return;
                              }

                              form.setFieldsValue({ invoice_file: file.name });
                              setFileListUpload([{ originFileObj: file, name: file.name }]);
                              message.success(`File ${file.name} berhasil dipilih`);
                            }
                          };
                          input.click();
                        }}
                      />
                    </Form.Item>
                    <p style={{
                      fontSize: '12px',
                      color: '#8c8c8c',
                      marginTop: '-16px',
                      marginBottom: '24px'
                    }}>
                      Supported format : pdf with max 2.5mb
                    </p>

                    <Form.Item
                      hasFeedback
                      name="deskripsi"
                      label="Deskripsi"
                      rules={rulesRequired()}
                      className="textarea-single-count"
                    >
                      <Input.TextArea
                        placeholder="Masukkan deskripsi"
                        rows={4} 
                        style={{ resize: 'none' }}
                        showCount
                        maxLength={500}
                      />
                    </Form.Item>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div className="footer-input-submit-wraper">
            <div className="footer-input-submit-wraper-button">
              <Row gutter={[16, 16]} justify="end" align="top">
                <Col xs={24} sm={12} lg={6}>
                  <Form.Item>
                    <button
                      type="primary"
                      htmlType="submit"
                      disabled={loading}
                      className="button-send-request-wraper"
                      style={{ cursor: 'pointer', width: '100%', padding: '10px 20px', whiteSpace: 'nowrap' }}
                    >
                      {loading ? <Spin indicator={<LoadingOutlined style={{ fontSize: 24, color: "white" }} spin />} /> : "KIRIM PENGAJUAN"}
                    </button>
                  </Form.Item>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </Form>
    </>
  );
};

export default OutstandingPaymentReq;
